<div *ngIf="this.form">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.data.form.get('id').value">Ajouter une NA</h3>
      <h3 *ngIf="this.data.form.get('id').value">Modifier une NA</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">

        <div class="col-sm-2">
            <mat-form-field class="full-width">
            <mat-label>Code</mat-label>
            <input matInput type="text" formControlName="code" maxlength="8" required>
                <mat-error *ngIf="form.get('code').hasError('required')">
                Veuillez saisir un code
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-9">
            <mat-form-field class="full-width">
            <mat-label>Libelle</mat-label>
            <input matInput name="libelle" formControlName="libelle" maxlength="50" required>
            <mat-error *ngIf="form.get('libelle').hasError('required')">
                Veuillez saisir un libelle
            </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-1">
         
        </div>
        
        
        <div class="col-sm-2">
          <mat-form-field class="full-width">
            <mat-label>CA2</mat-label>
            <mat-select formControlName="analyt2">
              <mat-option [value]="true" >Oui</mat-option>
              <mat-option [value]="false" >Non</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        
        <div class="col-sm-5">
          <app-autocomplete-with-code-form   
            name="cgCharge" [parent]="form"  
            libelle="CG Charge" 
            [objets]="this.data.cgCharges" 
            [(objet)]="cgCharge" [required]="true">
            </app-autocomplete-with-code-form>
        </div>

        <div class="col-sm-4">
            <app-autocomplete-with-code-form   
              name="typeComp" [parent]="form"  
              libelle="type de Complément" 
              [objets]="this.data.typeComps" 
              [(objet)]="typeComp">
              </app-autocomplete-with-code-form>
          </div>
          <div class="col-sm-1">
         
          </div>
    </form>
</div>
  
<div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>

    </div>
</div>

